import $ from 'jquery';

class Registration {
    constructor(){
        this.events();
    }

    events() {
        $("#register-button").on("click", this.createRegistration.bind(this));
        $("#bursary-button").on("click", this.checkForBursary.bind(this));
        $("#terms-cond").on("click", this.toggleTermsCond.bind(this));
        $(".del-reg-btn").on("click", this.li_delete.bind(this));           //  Deletion from list
        $("#delete-registration").on("click", this.btn_delete.bind(this));  //  Deletion from entry Page
        $("#helm-first-name").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#helm-last-name").on("focus", this.resetColor.bind(this));       // Change color back to default
        $("#crew-first-name").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#crew-last-name").on("focus", this.resetColor.bind(this));       // Change color back to default
        $("#ann-helm-gender").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#ann-crew-gender").on("focus", this.resetColor.bind(this));      // Change color back to default
        $("#ann-helm-boat-cat").on("focus", this.resetColor.bind(this));    // Change color back to default
        $("#email").on("focus", this.resetColor.bind(this));                // Change color back to default
        $("#ann-helm-disability-text").on("focus", this.resetColor.bind(this));
        $("#ann-crew-disability-text").on("focus", this.resetColor.bind(this));
        //////////////////////////////////////////////////////////////////////
        /*    Modification <MOD-A102>       REMOVED
        //////////////////////////////////////////////////////////////////////
        $("#school-year").on("focus", this.resetColor.bind(this));          // Change color back to default
        //////////////////////////////////////////////////////////////////////
        /*    Modification <MOD-A102>       ADDED
        ////////////////////////////////////////////////////////////////////*/
        $("#date-of-birth").on("focus", this.resetColorDOB.bind(this));        // Change color back to default
        $("#crew-date-of-birth").on("focus", this.resetColorCrewDOB.bind(this));        // Change color back to default
        //////////////////////////////////////////////////////////////////////
        $("#gdpr-yes").on("change", this.gdprClicked.bind(this));
        $("#gdpr-no").on("change", this.gdprClicked.bind(this));
        $("#medical-yes").on("change", this.medicalClicked.bind(this));
        $("#medical-no").on("change", this.medicalClicked.bind(this));
        $("#first-reg-yes").on("change", this.firstRegClicked.bind(this));
        $("#first-reg-no").on("change", this.firstRegClicked.bind(this));
        $("#ann-insurance-yes").on("change", this.annInsuranceClicked.bind(this));
        $("#ann-insurance-no").on("change", this.annInsuranceClicked.bind(this));
        $("#ann-helm-disability").on("change", this.helmDisabilityClicked.bind(this));
        $("#ann-crew-disability").on("change", this.crewDisabilityClicked.bind(this));
        $("#ann-helm-boat-cat").on("change", this.boatCategoryChanged.bind(this));
        $("#helm-first-name").on("change", this.helmNameChanged.bind(this));
        $("#helm-last-name").on("change", this.helmNameChanged.bind(this));
        $("#crew-first-name").on("change", this.helmNameChanged.bind(this));
        $("#crew-last-name").on("change", this.helmNameChanged.bind(this));
        
        //////////////////////////////////////////////////////////////////////
        /*    Modification <MOD-A102>       ADDED
        ////////////////////////////////////////////////////////////////////*/
        $("#date-of-birth").datepicker({
            changeYear: true,
            changeMonth: true,
            yearRange: "-20:+0",
            dateFormat: "dd-mm-yy"
          });
        /////////////////////////////////////////////////////////////////////*/
        //////////////////////////////////////////////////////////////////////
        /*    Modification <250501>       ADDED
        //  Annual Registration Data
        ////////////////////////////////////////////////////////////////////*/
        $("#crew-date-of-birth").datepicker({
            changeYear: true,
            changeMonth: true,
            yearRange: "-20:+0",
            dateFormat: "dd-mm-yy"
          });
        /////////////////////////////////////////////////////////////////////*/
    }

    resetColorDOB(e){
        $("#dob-too-old").addClass('d-none');
        $("#dob-too-young").addClass('d-none');
        $("#dob-format").addClass('d-none');
        this.resetColor(e);
    }
    resetColorCrewDOB(e){
        $("#crew-dob-too-old").addClass('d-none');
        $("#crew-dob-too-young").addClass('d-none');
        $("#crew-dob-format").addClass('d-none');
        this.resetColor(e);
    }
    resetColor(e){
        $(e.target).css('border-color','');
    }

    // Methods will go here
    helmNameChanged(e){
        //  If any part of any name has changed then the registration data needs removing and has to be checked in the
        //  Registration Route on Wordpress
        $('#annual-registration-data').addClass('d-none');
    }
    medicalClicked(e){
        $('#medical-message').hide();
        $('#med-yes-label').removeClass('error-message');
        $('#med-no-label').removeClass('error-message');
        if ($('#medical-yes').is(':checked')){
            $('#medical-message').removeClass('d-none');
            $('#medical-message').fadeIn(500);
        } else {
            $('#medical-message').addClass('d-none');
        }
    }
    gdprClicked(e){
        $('#gdpr-yes-label').removeClass('error-message');
        $('#gdpr-no-label').removeClass('error-message');
    }
    firstRegClicked(e){
        $('#first-reg-message').hide();
        $('#first-reg-yes-label').removeClass('error-message');
        $('#first-reg-no-label').removeClass('error-message');
        if ($('#first-reg-yes').is(':checked')){
            $('#first-reg-message').removeClass('d-none');
            $('#first-reg-message').fadeIn(500);
        } else {
            $('#first-reg-message').addClass('d-none');
        }
    }
    annInsuranceClicked(e){
        $('#ann-ins-msg').addClass('d-none');
        $('#ins-yes-label').removeClass('error-message');
        $('#ins-no-label').removeClass('error-message');
        if ($('#ann-insurance-no').is(':checked')){
            $('#ann-ins-msg').removeClass('d-none');
        }
    }
    helmDisabilityClicked(e){
        if ($(e.target).is(':checked')){
            $('#ann-helm-disability-text').removeClass('d-none');
        } else {
            $('#ann-helm-disability-text').addClass('d-none');
        }
        $('#ann-helm-disability-text').css('border-color','');
    }
    crewDisabilityClicked(e){
        if ($(e.target).is(':checked')){
            $('#ann-crew-disability-text').removeClass('d-none');
        } else {
            $('#ann-crew-disability-text').addClass('d-none');
        }
        $('#ann-crew-disability-text').css('border-color','');
    }
    boatCategoryChanged(e){
        if ($(e.target).val() == "Owned"){
            $("#ann-ins-row").removeClass('d-none');
        } else {
            $("#ann-ins-row").addClass('d-none');
        }
    }

    checkForBursary(e){
        var allValid = true;
        //  Check whether some required fields are missing
        if (!validTextField($("#helm-first-name"),1)){
            allValid=false;
        }
        if (!validTextField($("#helm-last-name"),1)){
            allValid=false;
        }
        if ($("#crew-first-name").length != 0){
            if (!validTextField($("#crew-first-name"),0)){
                allValid=false;
            }
        }
        if ($("#crew-last-name").length != 0){
            if (!validTextField($("#crew-last-name"),0)){
                allValid=false;
            }
        }
        if (!validEmailField($("#email"), 1)){
            allValid=false;
        }
        if (!validDateOfBirth($('#date-of-birth'),"H")){
            allValid = false;
        }
        if (allValid){
//  Need to deactivate the whole screen until reg is completed
            $(".mask").height($(document).height());
            $(".mask").show();
            $('#dys-spinner').addClass('d-flex');
            var tableData = $(e.target).parents("#registration");
            var eventID = tableData.data('event');
            var regID = tableData.data('reg');
            var newRegistration = {
                'title': "Registration",
                'helm_first_name': $("#helm-first-name").val(),
                'helm_last_name': $("#helm-last-name").val(),
                'crew_first_name': $("#crew-first-name").val(),
                'crew_last_name': $("#crew-last-name").val(),
                'email': $("#email").val(),
                'date_of_birth': $("#date-of-birth").val(),
                'boat_hire': ($("#boat-hire").is(':checked'))?"yes":"no"
            }
            if (eventID){   //  Update
                newRegistration.event_id  = eventID;
            } else {        //  Insert new
                newRegistration.ID = regID;
            }
            $.ajax({
                beforeSend:(xhr) => {
                    //  Added show spinner
                    $('#dys-spinner').show();
                    xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
                },
                url: dysData.root_url + '/wp-json/dys/v1/checkForBursary/',
                type: 'POST',
                data: newRegistration,
                success: (response) => {
                    $('#bursary-button').addClass('d-none');
                    $('#bursary-assigned-block').hide();
                    $('#bursary-assigned-block').removeClass('d-none');
                    if (response['APPLIED-BURSARY'] == "YES"){
                        //$('#bursary-assigned-block').html('Bursary Pending');
                        if (response['BURSARY-FEES'] > 0){
                            $('#fees-bursary').html('Fees Bursary: ' + response['BURSARY-FEES-NAME']);
                            $('#bursary-assigned-block').attr('data-fees', response['BURSARY-FEES']);
                        }
                        if (response['BURSARY-HIRE'] > 0){
                            $('#hire-bursary').html('Boat Loan Bursary: ' + response['BURSARY-HIRE-NAME']);
                            $('#bursary-assigned-block').attr('data-hire', response['BURSARY-HIRE']);
                        }
                    } else {
                        $('#bursary-assigned-block').html(response['REASON']);
                    }
                    $('#bursary-message').addClass('d-none');
                    $(".mask").hide();
                    $('#dys-spinner').removeClass('d-flex');
                    $('#bursary-assigned-block').fadeIn(500);
                },
                error: (response) => {
                    $('#bursary-button').addClass('d-none');
                    $('#bursary-assigned-block').hide();
                    $('#bursary-assigned-block').removeClass('d-none');
                    $('#bursary-assigned-block').html('Unable to check for Bursary');
                    $('#bursary-message').addClass('d-none');
                    $(".mask").hide();
                    $('#dys-spinner').removeClass('d-flex');
                    $('#bursary-assigned-block').fadeIn(500);
                    console.log("Invalid Data Response");
                    console.log(response);
                },
                
            });
        }
    }
    createRegistration(e){
        //$(e.target).prop('disabled', true);
        var seriesEvent = true;
        if (!$(e.target).hasClass('bttn-disabled')){
            if($("#form_type").val()!="SeriesEvent"){
                seriesEvent = false;
            }
            var allValid = true;
            //  Check whether some required fields are missing
            if (!validTextField($("#helm-first-name"),1)){
                allValid=false;
            }
            if (!validTextField($("#helm-last-name"),1)){
                allValid=false;
            }
            if (seriesEvent && !validTextField($("#crew-first-name"),0)){
                allValid=false;
            }
            if (seriesEvent && !validTextField($("#crew-last-name"),0)){
                allValid=false;
            }
            if (!validEmailField($("#email"), 1)){
                allValid=false;
            }
            if (!validDateOfBirth($('#date-of-birth'),"H")){
                allValid = false;
            }
            if (!gdprQuestionAnswered()){
                allValid = false;
            }
            if (!medicalQuestionAnswered()){
                allValid = false;
            }
//  2025-OCT    Don't allow helm and crew names to be the same
//  If the first name and last name of the helm and crew are the same it will remove the crew names.
            if (namesAreTheSame($("#helm-first-name"),$("#helm-last-name"),$("#crew-first-name"),$("#crew-last-name"))){
                $("#crew-first-name").val('');
                $("#crew-last-name").val('');
            }
//  2025-OCT    End of Changes
            if (seriesEvent && !firstRegQuestionAnswered()){
                allValid = false;
            }
            if (!$('#annual-registration-data').hasClass('d-none')){
                //  Only enter this section if the annual data fields are visible.
                if (!validSelect($("#ann-helm-gender")) && !$("#ann-helm-title").hasClass('d-none')){
                    allValid = false;
                }
                if (!validSelect($("#ann-crew-gender")) && !$("#ann-crew-title").hasClass('d-none')){
                    allValid = false;
                }
                if (!$("#ann-helm-boat-cat").hasClass('d-none') && !validSelect($("#ann-helm-boat-cat"))){
                    allValid = false;
                }
                if (!$("#ann-crew-dob").hasClass('d-none') && !validDateOfBirth($('#crew-date-of-birth'),"C")){
                    allValid = false;
                }
                if (!insuranceQuestionAnswered()){
                    allValid = false;
                }
                if ($("#ann-helm-disability").is(':checked')){
                    if ($("#ann-helm-disability-text").val().length == 0){
                        allValid = false;
                        $("#ann-helm-disability-text").css("border-color","red");
                    }
                }
                if ($("#ann-crew-disability").is(':checked')){
                    if ($("#ann-crew-disability-text").val().length == 0){
                        allValid = false;
                        $("#ann-crew-disability-text").css("border-color","red");
                    }
                }
            }
            if (allValid){
                //  Need to deactivate the whole screen until reg is completed
                $(".mask").height($(document).height());
                $(".mask").show();
                $('#dys-spinner').addClass('d-flex');
                var tableData = $(e.target).parents("#registration");
                var eventID = tableData.data('event');
                var regID = tableData.data('reg');
                var newRegistration = {
                    'title': "Registration",
                    'helm_first_name': $("#helm-first-name").val(),
                    'helm_last_name': $("#helm-last-name").val(),
                    'crew_first_name': $("#crew-first-name").val(),
                    'crew_last_name': $("#crew-last-name").val(),
                    'email': $("#email").val(),
                    'boat_type': $("#boat-type").val(),
                    'date_of_birth': $("#date-of-birth").val(),
                    'sail_number': $("#sail-number").val(),
                    'gdpr_consent': $('input[name=GDPR]:checked').val(),
                    'medical_form': $('input[name=Medical]:checked').val(),
                    'boat_hire': ($("#boat-hire").is(':checked'))?$('input[name=boatHire]:checked').val():'no',
                    'first_reg': $('input[name=first-reg]:checked').val(),
                    //  ADDED FOR BURSARIES
                    'bursary_fees': $('#bursary-assigned-block').data('fees'),
                    'bursary_hire': $('#bursary-assigned-block').data('hire'),
                    //*********************
                    'status' : 'publish'
                }
                //  250501  Annual Registration form fields added
                if (!($("#ann-helm-gender").hasClass('d-none'))){
                    newRegistration.helm_gender = $("#ann-helm-gender").val();
                }
                if (!$("#ann-crew-gender").hasClass('d-none')){
                    newRegistration.crew_gender = $("#ann-crew-gender").val();
                }
                if (!$("#ann-crew-dob").hasClass('d-none')){
                    newRegistration.crew_DOB = $("#crew-date-of-birth").val();
                }
                if ($("#ann-helm-disability").is(':checked') && $("#ann-helm-disability-text").val().length != 0){
                    newRegistration.helm_disability = $("#ann-helm-disability-text").val();
                }
                if ($("#ann-crew-disability").is(':checked') && $("#ann-crew-disability-text").val().length != 0){
                    newRegistration.crew_disability = $("#ann-crew-disability-text").val();
                }
                if (!$("#ann-helm-boat-cat").hasClass('d-none')){
                    newRegistration.boat_category = $("#ann-helm-boat-cat").val();
                }
                if ($("#ann-insurance-yes").is(':checked') && !$("#ann-ins-row").hasClass('d-none')){
                    newRegistration.boat_insurance = $("#ann-insurance-yes").val();
                }
                //  Now see if the user has been entering registration data. If so then pass 'annual_reg_data_included'
                if (!$('#annual-registration-data').hasClass('d-none')){
                    var helmCrewFlags = 0;
                    if (!$('#ann-helm-title').hasClass('d-none')){
                        helmCrewFlags += 2;
                    }
                    if (!$('#ann-crew-title').hasClass('d-none')){
                        helmCrewFlags += 1;
                    }
                    newRegistration.annual_reg_data_included = helmCrewFlags;
                }
                //*********************
                //  Now add details for whether update or insert
                if (eventID){
                    newRegistration.event_id  = eventID;
                } else {
                    newRegistration.ID = regID;
                }
                $.ajax({
                    beforeSend:(xhr) => {
                        //  Added show spinner
                        $('#dys-spinner').show();
                        xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
                    },
                    url: dysData.root_url + '/wp-json/dys/v1/manageRegistration/',
                    type: 'POST',
                    data: newRegistration,
                    success: (response) => {
                        if (response['NEED-ANNUAL-REGISTRATION'] == "YES"){
                            if (response['HELM'] == 'NO'){
                                $('#ann-helm-gender').addClass('d-none');
                                $('#ann-helm-disability').addClass('d-none');
                                $('#ann-helm-disability-label').addClass('d-none');
                                $('#ann-reg-boat-cat').addClass('d-none');
                                $('#ann-ins-row').addClass('d-none');
                                $('#ann-helm-title').addClass('d-none');
                            } else {
                                $('#ann-helm-gender').removeClass('d-none').css("border-color", "red");
                                $('#ann-helm-disability').removeClass('d-none').css("border-color", "red");
                                $('#ann-helm-disability-label').removeClass('d-none');
                                $('#ann-reg-boat-cat-row').removeClass('d-none');
                                $('#ann-helm-boat-cat').removeClass('d-none').css("border-color", "red");
                                $('#ins-yes-label').addClass('error-message');
                                $('#ins-no-label').addClass('error-message');
                                $('#ann-helm-title').removeClass('d-none');
                                $('#annual-registration-data').removeClass('d-none');
                            }
                            if (response['CREW'] == 'NO'){
                                $('#ann-crew-gender').addClass('d-none');
                                $('#ann-crew-dob').addClass('d-none');
                                $('#ann-crew-disability').addClass('d-none');
                                $('#ann-crew-disability-label').addClass('d-none');
                                $('#ann-crew-title').addClass('d-none');
                            } else {
                                $('#ann-crew-gender').removeClass('d-none').css("border-color", "red");
                                $('#ann-crew-dob').removeClass('d-none').css("border-color", "red");
                                $('#ann-crew-disability').removeClass('d-none').css("border-color", "red");
                                $('#ann-crew-disability-label').removeClass('d-none').css("border-color", "red");
                                $('#ann-crew-title').removeClass('d-none');
                                $('#annual-registration-data').removeClass('d-none');
                            }
                            $(".mask").hide();
                            $('#dys-spinner').removeClass('d-flex');
                        } else {
                            window.location.replace(document.referrer);
                        }
                    },
                    error: (response) => {
                        console.log("Invalid Data Response");
                        console.log(response);
                    },
                    
                });
            } else {
                console.log("Validation Error");
            }
        }
    }
    li_delete(e){
        if (!$(e.target).hasClass('bttn-disabled')){
            dialogRegistration(e,'li');
        }
    }
    btn_delete(e){
        if (!$(e.target).hasClass('bttn-disabled')){
            dialogRegistration(e,'');
        }
    }
    toggleTermsCond(e){
        if ($('#terms-cond').is(':checked')){
            $('#register-button').removeClass('bttn-disabled');
        } else {
            $('#register-button').addClass('bttn-disabled');
        }
    }
}
function dialogRegistration(e, src){
    
        $('.dialog-text').text('Are You Sure?');
        $('#dialog-confirm').dialog({
            resizable: false,
            height: "auto",
            draggable: false,
            width: 400,
            modal: true,
            show: {
                effect: "fadeIn"
            },
            hide: {
                effect: "fadeOut"
            },
            closeOnEscape: true,
            buttons: [
                {
                    text: "Yes",
                    click: function(){
                        
                        $(this).dialog("close");
                        deleteRegistration(e,src);
                    }
                },
                {
                    text: "No",
                    click: function(){
                        $(this).dialog("close");
                    }
                }
            ]
        });

        $('#dialog-confirm').dialog("open");
        


}
function deleteRegistration(e, src){
    if (src=="li"){
        var thisRegistration = $(e.target).closest("li");
    } else {
        var thisRegistration = $(e.target);
    }
    var regToDelete = {
        'ID': thisRegistration.data('id')
    };

    $(".mask").height($(document).height());
    $(".mask").show();
    $('#dys-spinner').addClass('d-flex');
    $.ajax({
        beforeSend:(xhr) => {
            xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
        },
        url: dysData.root_url + '/wp-json/dys/v1/manageRegistration/',
        type: 'DELETE',
        data: regToDelete,
        success: (response) => {
            if (src == 'li'){
                thisRegistration.fadeOut(); //  If from list then remove list item
            } else {
                window.location.replace(document.referrer); //  If from single page then return to previous
            }
            $('#dys-spinner').removeClass('d-flex');
            $(".mask").hide();
        },
        error: (response) => {
            console.log("Sorry, unable to delete");
            console.log(response);
        }
    });
}
function validTextField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[A-Za-z ]+$/) && fieldText.length != 0){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}
function validSelect(field){
    var fieldValue = $(field).val();
    var fieldValid = true;
    if (fieldValue == 0){
        fieldValid = false;
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}

function validEmailField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}
///////////////////////////////////////////////////////////////////////
/*    Modification <MOD-A102>       ADDED
//////////////////////////////////////////////////////////////////////*/
function validDateOfBirth(target,helmOrCrew){
    var dateOfBirthValid = true;
    if ($(target).val().length <= 0){
        dateOfBirthValid = false;
    } else {
        switch (getAgeGroupFromDOB($(target).val(), $("#reg-event-year").val())){
            case "Too Old":
                if (helmOrCrew == "H"){
                    $("#dob-too-old").removeClass('d-none');
                } else {
                    $("#crew-dob-too-old").removeClass('d-none');
                }
                dateOfBirthValid = false;
                break;
            case "Too Young":
                if (helmOrCrew == "H"){
                    $("#dob-too-young").removeClass('d-none');
                } else {
                    $("#crew-dob-too-young").removeClass('d-none');
                }
                dateOfBirthValid = false;
                break;
            case "Bad Date":
                if (helmOrCrew == "H"){
                $("#dob-format").removeClass('d-none');
                } else {
                $("#crew-dob-format").removeClass('d-none');
                }
                dateOfBirthValid = false;
                break;
            default:
                break;

        }
    }
    if (!dateOfBirthValid){
        $(target).css("border-color", "red");
    }
    return dateOfBirthValid;
}
///////////////////////////////////////////////////////////////////////
function medicalQuestionAnswered(){
    var medicalValid = true;
    if ($('#medical-yes').is(':checked') ||
        $('#medical-no').is(':checked')){
        medicalValid = true;
    } else {
        medicalValid = false;
    }
    if (!medicalValid){
        $('#med-yes-label').addClass("error-message");
        $('#med-no-label').addClass("error-message");
    }
    return medicalValid;
}
function gdprQuestionAnswered(){
    var gdprValid = true;
    if ($('#gdpr-yes').is(':checked') ||
        $('#gdpr-no').is(':checked')){
        gdprValid = true;
    } else {
        gdprValid = false;
    }
    if (!gdprValid){
        $('#gdpr-yes-label').addClass("error-message");
        $('#gdpr-no-label').addClass("error-message");
    }
    return gdprValid;
}
function insuranceQuestionAnswered(){
    var insuranceValid = true;
    if ($('#ann-insurance-yes').is(':checked')) {
        insuranceValid = true;
    } else {
        if ($("#ann-helm-boat-cat").val() == "Owned"){
            insuranceValid = false;
        }
    }
    if (!insuranceValid){
        $('#ins-yes-label').addClass("error-message");
        $('#ins-no-label').addClass("error-message");
    }
    return insuranceValid;
}
function firstRegQuestionAnswered(){
    var firstRegValid = true;
    if ($('#first-reg-yes').is(':checked') ||
        $('#first-reg-no').is(':checked')){
            firstRegValid = true;
    } else {
        firstRegValid = false;
    }
    if (!firstRegValid){
        $('#first-reg-yes-label').addClass("error-message");
        $('#first-reg-no-label').addClass("error-message");
    }
    return firstRegValid;
}
function getAgeGroupFromDOB(DOB,eventYear){
    if (DOB.includes("/")){
        return "Bad Date";
    }
    var arrayOfStrings = DOB.split("-");
    var dd = arrayOfStrings[0];
    var mm = arrayOfStrings[1] - 1;
    var yy = arrayOfStrings[2];

    var lastAugDate = new Date(eventYear,7,31);
    var dateOfBirth = new Date(yy,mm,dd);

    var age = lastAugDate.getFullYear() - dateOfBirth.getFullYear();
    var m = lastAugDate.getMonth() - dateOfBirth.getMonth();
    if (m < 0 || (m === 0 && lastAugDate.getDate() < dateOfBirth.getDate())) {
        age--;
    }
    switch (true){
        case age < 3:
            return "Too Young"
            break;
        case age < 13:
            return "Jnr";
            break;
        case (age >= 13 && age <= 15):
            return "Int";
            break;
        case (age >= 16 && age <= 18):
            return "Snr";
            break;
        default:
            return "Too Old";
    }
}
//  2025-OCT    Don't allow helm and crew names to be the same
function namesAreTheSame(helmFirstName, helmLastName, crewFirstName, crewLastName){
    if (helmFirstName.val() == crewFirstName.val() &&
        helmLastName.val() == crewLastName.val()){
        return true;
    } else {
        return false;
    }
}
//  2025-OCT    End of changes
export default Registration;

